import { ref, getValues } from '@dbk-legacy/muster/utils';
import muster from '@dbk-legacy/muster';
import { variable, sortable } from '@dbk-legacy/muster/helpers';

import map from 'lodash/fp/map';
import lget from 'lodash/get';
import findIndex from 'lodash/fp/findIndex';

import startOfToday from 'date-fns/start_of_today';
import { addDays, addMonths, ymd } from '../../../../src/utils/date';
import sortableList from '../../../../src/utils/sortable-list';
import calendar from '../../../../src//muster/calendar-modal';
import ui from '../data/ui.json';

function populateDateRange(tabs, today) {
  //const today = startOfToday();

  tabs.map(tab => {
    if (tab.periodNo && tab.periodType) {
      tab.fromDate = today;
      if (tab.periodType === 'days') tab.toDate = addDays(tab.periodNo, tab.fromDate);
      if (tab.periodType === 'months') tab.toDate = addMonths(tab.periodNo, tab.fromDate);
      tab.toDate = addDays(-1, tab.toDate);
    } else {
      tab.fromDate = null;
      tab.toDate = null;
    }
    return tab;
  });

  return tabs;
}

export default () => {
  let today = startOfToday();
  let sevenDaysFromToday = addDays(6, today);
  let tabs = populateDateRange(lget(ui, 'maturities.tabs'), today);
  const setDateasOfDate = (asOfDate) => {
    today = new Date(asOfDate);
    sevenDaysFromToday = addDays(6, today);
    tabs = populateDateRange(lget(ui, 'maturities.tabs'), today);
  }

  let TAB_INDEX = 0;
  let DATE_CHANGED = 0;

  return muster()
    .match('roster.maturitiesDates.*', (requests, { watchValues, set, get }) =>
      watchValues(['app.user.selectedPortfolioId', 'maturities.dateChanged'])
      .switchMap(([portfolioId, dateChanged]) =>
      getValues(get(['portfolio.overallMarketValue.asOfDate'])).then(async ([asOfDate]) => {
        setDateasOfDate(asOfDate);
        const [tabIndex] = await getValues(get(['maturities.tabIndex']));
        return getValues(get(['maturities.fromDate', 'maturities.toDate']))
          .then(([fromDate, toDate]) => {
            if (tabIndex === 3) {
              fromDate
            } else {
              fromDate = today,
                toDate = ymd(tabs[tabIndex].toDate);
            }
            return requests.map(({ req, res }) => {
              return res.redirect(`roster.data.maturitiesByIdCh["${portfolioId}"].dates["${ymd(fromDate)}"]["${toDate}"].${req.params['*']}`)
            })
          })
      })))
    .match('roster.maturities.*', (requests, { watchValues }) =>
      watchValues('app.user.selectedPortfolioId')
        .map(([portfolioId]) => 
          requests.map(({ req, res }) => 
            res.redirect(`roster.data.maturitiesByIdCh["${portfolioId}"].${req.params['*']}`)
    )))
    .path('maturities.dateChanged', variable(DATE_CHANGED))
    .path('maturities.fromDate', variable(ymd(today)))
    .path('maturities.showDateRange', variable(false))
    .path('maturities.toDate', variable(ymd(sevenDaysFromToday)))
    .path('maturities.assets.length', ref('roster.maturitiesDates.assets.length'))
    .match('maturities.assets[{integers:i}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`roster.maturitiesDates.assets[${req.params.i}].${req.params.k}`)
    ))
    .match('maturities.assetsSorted[{integers:i}].*', sortable({
      fromList: 'maturities.assets',
      toList: 'maturities.assetsSorted',
      listLength: ref('maturities.assets.length'),
      isAscending: ref('ui.state.maturities.ascending'),
      sortByKey: ref('ui.state.maturities.selectedKey'),
    }))
    .path('maturities.otherPeriodAssets.length', ref('roster.maturitiesDates.otherPeriodAssets.length'))
    .match('maturities.otherPeriodAssets[{integers:i}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`roster.maturitiesDates.otherPeriodAssets[${req.params.i}].${req.params.k}`)
    ))
    .match('maturities.otherPeriodAssets[{integers:i}].onSelect', {
      call: async ({ req }, { set }) => {
        const { periodType, periodNo } = req.args[0];
        const tabIndex = findIndex({ periodType: periodType, periodNo: periodNo }, tabs);
        if (tabIndex >= 0) {
          await set('maturities.selectedTabIndex', tabIndex);
        }
      },
    })
    .path('maturities.maturityDates', ref('roster.maturities.maturityDates'))
    .path('maturities.detailTitle', variable())
    .path('maturities.customTitle', {
      call: async ({ req }, { set }) => {
        const Title = req.args[0];  
        await set('ui.customtitle', Title);
      },
    })
    .path('maturities.detailMarketValue', variable())
    .path('maturities.detailAssets', variable())
    .path('maturities.assetsSorted', sortableList({
      fromPath: 'maturities.detailAssets',
      toPath: 'maturities.assetsSorted',
      isAscending: 'ui.state.maturitiesAssets.ascending',
      sortByKey: 'ui.state.maturitiesAssets.selectedKey',
    }))
    .match('maturities.selectedTab.*', (requests, { watchValues }) =>
      watchValues('maturities.selectedTabIndex')
        .map(([tabIndex]) => 
          requests.map(({ req, res }) => 
            res.value(lget(tabs, `[${tabIndex}].${req.params['*']}`))
    )))
    .path('maturities.selectedTabIndex', {
      get: ({ res }) => res.value(TAB_INDEX),
      set: ({ req, res }, { set }) => {
        TAB_INDEX = req.value;
        const tab = tabs[TAB_INDEX];

        if (tab.fromDate !== null && tab.toDate !== null) {
          set('maturities.fromDate', ymd(tab.fromDate));
          set('maturities.toDate', ymd(tab.toDate));
          set('maturities.dateChanged', ++DATE_CHANGED);
        }
          set('maturities.tabIndex', req.value);
        return res.ok(); 
      },
    })
    .path('maturities.tabIndex', variable(0))
    .path('maturities.tabs.length', ({ res }) => res.value(tabs.length))
    .match('maturities.tabs[{integers:i}][{keys:k}]', requests =>
      requests.map(({ req, res }) =>
        res.value(lget(tabs, `[${req.params.i}].${req.params.k}`))
    ))
    .path('maturities.onCalendarDone', {
      call: async ({ req }, { set }) => {
        const { fromDate, toDate } = req.args[0];

        if (fromDate || toDate) {
          await set('maturities.fromDate', ymd(fromDate ? fromDate : toDate));
          await set('maturities.toDate', ymd(toDate ? toDate : fromDate));
          await set('maturities.dateChanged', ++DATE_CHANGED);

          const tabIndex = findIndex({ periodType: 'custom' }, tabs);
          if (tabIndex >= 0) {
            await set('maturities.selectedTabIndex', tabIndex);
          }
        }
      },
    })
    //.path('maturities.sevenDaysFromToday', variable(""))
    .import('maturities.calendar', calendar(), {
      onDone: ref('maturities.onCalendarDone'),
    })
    .path('maturities.resetTo7days', {
      call: async ({ req }, { set, get }) => {
        await set('maturities.selectedTabIndex', 0);
        const [ asOfDate ] = await getValues(get(['portfolio.overallMarketValue.asOfDate']))
        await set('maturities.fromDate', new Date(asOfDate));
        let sevenDaysFromToday = new Date(asOfDate);
        sevenDaysFromToday.setDate(sevenDaysFromToday.getDate() + 6);
        await set('maturities.toDate', sevenDaysFromToday);
      }
    })
}
